<template>
  <div class="detail-page">
    <div class="detail-page__left">
      <CardLeftBlock
          :name="$t('disposal_id.localization_value.value')"
          :value="'#'+DHLReturn.data.Order.getId()"
          :backgroundImage="'product-admin'"
      >
        <template slot="body">
          <div class="card-detail-left__date mt-1">
            {{ new Date() | moment("DD MMM, YYYY") }}
          </div>
        </template>
      </CardLeftBlock>
    </div>

    <div class="detail-page__right">
      <CardRightBlock>
        <template slot="header">
          <div class="order-create__head">
            <div class="order-create__head-line">
              <div class="order-create__header-col"
                   v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                <div class="admin-edit" @click="editTranslate(['ex_backTo',])"></div>
<!--                <router-link :to="goRouterBack()" class="order-create__head-back">-->
<!--                  <LinkBack-->
<!--                      :value="$t('ex_backTo.localization_value.value')"-->
<!--                  />-->
<!--                </router-link>-->
                <LinkBack
                    :value="$t('ex_backTo.localization_value.value')"
                    @click.native="goRouterBack()"
                />
              </div>
            </div>
            <div class="order-create__head-title color-red"
                 v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
              <div class="admin-edit" @click="editTranslate(['disposal_DHLReturn',])"></div>
              {{ $t('breadcrumbs_NewDHLReturnOrder.localization_value.value') }}
            </div>
          </div>
        </template>

        <template slot="body">
          <div class="order-create__section">
            <div class="order-create__row custom-row">
              <div class="order-create__col custom-col">
                <div class="order-create__title-horizontal">
                  <TitleHorizontal
                      :value="$t('ex_sendersInformation.localization_value.value')"
                  />
                </div>

                <div class="order-create__table block-table">
                  <div class="block-table__row">
                    <div class="block-table__col block-table__col--20">
                      <div class="block-table__label">
                        {{ $t('express_ContactName.localization_value.value') }}
                      </div>
                      <div class="block-table__content">
                        <ValueHelper
                            :value="DHLReturn.data.personal.information.personalName"
                        />
                      </div>
                    </div>
                    <div class="block-table__col block-table__col--20">
                      <div class="block-table__label">
                        {{ $t('common_phone.localization_value.value') }}
                      </div>
                      <div class="block-table__content">
                        <ValueHelper
                            :value="DHLReturn.data.personal.information.personalPhone"
                        />
                      </div>
                    </div>
                    <div class="block-table__col block-table__col--20">
                      <div class="block-table__label">
                        {{ $t('express_Email.localization_value.value') }}
                      </div>
                      <div class="block-table__content">
                        <ValueHelper
                            :value="DHLReturn.data.personal.information.personalEmail"
                        />
                      </div>
                    </div>
                  </div>
                </div>


                <div class="order-create__title-horizontal mt-3">
                  <TitleHorizontal
                      :value="$t('ex_senderAddress.localization_value.value')"
                  />
                </div>

                <div class="order-create__table block-table">
                  <div class="block-table__row">
                    <div class="block-table__col block-table__col--20">
                      <div class="block-table__label">
                        {{ $t('common_expressStreet.localization_value.value') }}
                      </div>
                      <div class="block-table__content">
                        <ValueHelper
                            :value="DHLReturn.data.delivery.delivery.address"
                        />
                      </div>
                    </div>
                    <div class="block-table__col block-table__col--20">
                      <div class="block-table__label">
                        {{ $t('common_houseNum.localization_value.value') }}
                      </div>
                      <div class="block-table__content">
                        <ValueHelper
                            :value="DHLReturn.data.delivery.delivery.address2"
                        />
                      </div>
                    </div>
                    <div class="block-table__col block-table__col--20">
                      <div class="block-table__label">
                        {{ $t('common_apartmentNumber.localization_value.value') }}
                      </div>
                      <div class="block-table__content">
                        <ValueHelper
                            :value="DHLReturn.data.delivery.delivery.apartmentNumber"
                        />
                      </div>
                    </div>
                    <div class="block-table__col block-table__col--20">
                      <div class="block-table__label">
                        {{ $t('common_city.localization_value.value') }}
                      </div>
                      <div class="block-table__content">
                        <ValueHelper
                            :value="DHLReturn.data.delivery.delivery.city"
                        />
                      </div>
                    </div>
                    <div class="block-table__col block-table__col--20">
                      <div class="block-table__label">
                        {{ $t('common_country.localization_value.value') }}
                      </div>
                      <div class="block-table__content">
                        <ValueHelper
                            :value="DHLReturn.data.delivery.delivery.country"
                            :deep="'label'"
                        />
                      </div>
                    </div>
                    <div class="block-table__col block-table__col--20 mt-3">
                      <div class="block-table__label">
                        {{ $t('common_zipCode.localization_value.value') }}
                      </div>
                      <div class="block-table__content">
                        <ValueHelper
                            :value="DHLReturn.data.delivery.delivery.zip"
                        />
                      </div>
                    </div>
                  </div>
                </div>


                <div class="order-create__title-horizontal mt-3">
                  <TitleHorizontal
                      :value="$t('express_LabelExpirationDate.localization_value.value')"
                  />
                </div>

                <div class="order-create__table block-table">
                  <div class="block-table__row">
                    <div class="block-table__col block-table__col--20">
                      <div class="block-table__label">
                        {{ $t('common_date.localization_value.value') }}
                      </div>
                      <div class="block-table__content">
                        <ValueHelper
                            :value="DHLReturn.data.deliveryDate"
                        />
                      </div>
                    </div>
                  </div>
                </div>


                <div class="order-create__title-horizontal mt-3">
                  <TitleHorizontal
                      :value="$t('payments_productsContent.localization_value.value')"
                  />
                </div>

                <div class="order-create__table block-table">
                  <div class="block-table__row">
                    <div class="block-table__col block-table__col--20">
                      <div class="block-table__label">
                        {{ $t('payments_productsDescription.localization_value.value') }}
                      </div>
                      <div class="block-table__content">
                        <ValueHelper
                            :value="DHLReturn.data.productsDescription"
                        />
                      </div>
                    </div>

                    <div class="block-table__col block-table__col--20">
                      <div class="block-table__label">
                        {{ $t('express_comment.localization_value.value') }}
                      </div>
                      <div class="block-table__content">
                        <ValueHelper
                            :value="DHLReturn.data.comment"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="order-create__title-horizontal mt-3">
                  <TitleHorizontal
                      :value="$t('ex_packaging.localization_value.value')"
                  />
                </div>

                <div class="order-create__row custom-row">
                  <div class="order-create__col custom-col">
                    <div class="order-create__table block-table">
                      <div class="block-table__row">
                        <div class="block-table__col block-table__col--fit">
                          <div class="block-table__label">
                            {{ $t('packaging_Weight.localization_value.value') }}
                          </div>
                          <div class="block-table__content">
                            {{ DHLReturn.data.packaging.packaging.weight }}kg
                          </div>
                        </div>
                        <div class="block-table__col block-table__col--fit">
                          <div class="block-table__label">
                            {{ $t('packaging_Length.localization_value.value') }}
                          </div>
                          <div class="block-table__content">
                            {{ DHLReturn.data.packaging.packaging['length'] }}cm
                          </div>
                        </div>
                        <div class="block-table__col block-table__col--fit">
                          <div class="block-table__label">
                            {{ $t('packaging_Width.localization_value.value') }}
                          </div>
                          <div class="block-table__content">
                            {{ DHLReturn.data.packaging.packaging.width }}cm
                          </div>
                        </div>
                        <div class="block-table__col block-table__col--fit">
                          <div class="block-table__label">
                            {{ $t('packaging_Height.localization_value.value') }}
                          </div>
                          <div class="block-table__content">
                            {{ DHLReturn.data.packaging.packaging.height }}cm
                          </div>
                        </div>
                        <div class="block-table__col block-table__col--fit">
                          <div class="block-table__label">
                            {{ $t('express_Volume.localization_value.value') }}
                          </div>
                          <div class="block-table__content">
                            {{ DHLReturn.data.packaging.packaging.volumeWeight }}kg
                          </div>
                        </div>
                      </div>



                      <div class="block-table__row"
                           v-if="DHLReturn.data.packaging.packaging.insurance"
                      >
                        <div class="block-table__col block-table__col--40">
                          <div class="block-table__content mt-3">
                            <DefaultCheckbox
                                :label="$t('express_INeedInsurance.localization_value.value') + ' — $' + DHLReturn.data.packaging.packaging.insurancePrice"
                                :value="true"
                                :disabled="true"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </template>
        <template slot="footer">
          <div class="order-create__footer">

            <div class="order-create__footer-link">
              <span @click="goRouterBack()"
                           class="site-link site-link--alt"
              >
                {{ $t('common_cancel.localization_value.value') }}
              </span>
            </div>

            <div class="order-create__footer-btn ml-auto">
            </div>

          </div>
        </template>
      </CardRightBlock>

    </div>
  </div>
</template>

<script>
import CardLeftBlock from "../../../../../../components/coreComponents/CardLeftBlock/CardLeftBlock.vue";
import CardRightBlock from "../../../../../coreComponents/CardRightBlock/CardRightBlock.vue";
import LinkBack from "../../../../../UI/buttons/LinkBack/LinkBack.vue";
import {DHLReturnMixin} from "@/mixins/DHLReturnMixins/DHLReturnMixin";
import ValueHelper from "@/components/coreComponents/ValueHelper/ValueHelper";
import TitleHorizontal from "@/components/coreComponents/TitleHorizontal/TitleHorizontal";
import DefaultCheckbox from "@/components/UI/checkboxes/DefaultCheckbox/DefaultCheckbox";

export default {
  name: "DHLReturnShow",

  components: {
    DefaultCheckbox,
    TitleHorizontal,
    ValueHelper,
    CardLeftBlock,
    CardRightBlock,
    LinkBack,
  },

  mixins: [DHLReturnMixin],

  props: {
    DHLReturn: {
      type: Object,
    },
  },

  data() {
    return {
    }
  },

  methods: {

  }
}
</script>

<style lang="scss">

.hide-upc {
  opacity: 0.5;
  pointer-events: none;
}

.product-progress-steps {
  max-width: 625px;
}

</style>
